export default __webpack_public_path__ + "media/images/star-a95e6fe28d14a0da1d5c3df3ccc9b197.svg";